import React, { useEffect, useState, useContext, useRef } from 'react';
import { getOrganizationalUnit, addHandlerToOrganizationalUnit, addMemberToOrganizationalUnit, removeEmployeeFromOrganizationalUnit, deleteOrganizationalUnit } from '../services/api_org_unit';
import { getEmployeesWithActiveContract } from '../services/api_calendar';
import { AuthContext } from '../contexts/auth';
import Footer from '../components/footer';
import { TrashIcon, PencilIcon, CheckIcon } from '@heroicons/react/24/outline';
import { Link, useParams } from 'wouter';
import OrgAddEmployeeRoleHandlers from '../components/org_unit_add_handlers';
import OrgAddEmployeeRoleMembers from '../components/org_unit_add_members';
import { addOusPermission, getOusPermissions, removeOusPermission } from '../services/api_permissions';
import { useLocation } from 'wouter';
import Swal from 'sweetalert2';
import Fetching from '../components/fetching';
import PermissionsTable from '../components/permessi_table';
import PopoverComponentCustom from '../components/popover_component';

  

export default function DetailOrgUnit() {
    const backgroundColor = 'bg-indigo-200';
    const { ou_id } = useParams();
    const [unitData, setUnitData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const { loading, token, profile } = useContext(AuthContext);
    const [showModal, setShowModal] = useState(false);
    const [isVisibleHandlers, setIsVisibleHandlers] = useState(false);
    const [isVisibleMembers, setIsVisibleMembers] = useState(false);
    const [selectedEmployeesHandlers, setSelectedEmployeesHandlers] = useState([]);
    const [selectedEmployeesMembers, setSelectedEmployeesMembers] = useState([]);
    const [dipendenti, setDipendenti] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [location, setLocation] = useLocation();
    const [parentUnitData, setParentUnitData] = useState(null);
    const [isErrorParent, setIsErrorParent] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [ouPermissions, setOuPermissions] = useState([]);
    const [showPermissionsTable, setShowPermissionsTable] = useState(false);
    const errorRef = useRef(null);

    useEffect(() => {
        setIsLoading(true);
        setIsError(false);
        getOrganizationalUnit(token, ou_id).then((data) => {
            setUnitData(data.data);
            setIsLoading(false);
        }).catch(error => {
            console.error('Error fetching units:', error);
            setIsError(true);
            setIsLoading(false);
        });
    }, []);

    useEffect(() => {
        if (unitData?.parent) {
          setIsErrorParent(false);
          getOrganizationalUnit(token, unitData.parent).then((data) => {
            setParentUnitData(data.data);
          }).catch(error => {
            console.error('Error fetching parent unit:', error);
            setIsErrorParent(true);
          });
        }
      }, [unitData.parent]);
    

    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const activePermissions = await getOusPermissions(token, ou_id);
                setOuPermissions(activePermissions);
            } catch (error) {
                console.error("Error fetching organizational unit permissions:", error);
                setIsError(true);
            } finally {
                setIsLoading(false);
            }
        };
    
        if (ou_id && profile.customer_type !== 'employee') {
            setIsLoading(true);
            fetchPermissions();
        }
    }, [ou_id, token, profile.customer_type]);

    const availableEmployees = Array.isArray(dipendenti) ? dipendenti.filter(employee => {
        return (!unitData.handlers || !unitData.handlers.find((handler) => handler.id === employee.id)) &&
               (!unitData.members || !unitData.members.find((member) => member.id === employee.id));
    }) : [];
    
    const handleDeleteOu = async () => {
        const callback = async () => {
            try {
                await deleteOrganizationalUnit(token, ou_id)
                setShowModal(false);
                Swal.fire({
                    title: 'Unità Organizzativa eliminata con successo!',
                    icon: 'success',
                });
                setLocation('/organization');

            } catch (error) {
                console.error('Errore durante l\'eliminazione dell\'unità organizzativa:', error)
                Swal.fire({
                    text: 'Errore durante l\'eliminazione dell\'unità organizzativa',
                    icon: 'error'
                });
            }
        };

        if (unitData.is_parent) {
            Swal.fire({
                icon: 'question',
                text: `Sei sicuro di voler procedere con l'eliminazione dell'Unità Organizzativa ${unitData.name.toUpperCase()}? Verranno eliminate anche le unità ad essa collegate.`,
                showCancelButton: true,
                confirmButtonText: 'Sì, elimina',
                cancelButtonColor: '#d1d5db',
                cancelButtonText: 'No',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    callback();
                }
            });
        } else {
            Swal.fire({
                icon: 'question',
                text: `Sei sicuro di voler eliminare l'Unità Organizzativa ${unitData.name.toUpperCase()}?`,
                showCancelButton: true,
                confirmButtonText: 'Sì, elimina',
                cancelButtonColor: '#d1d5db',
                cancelButtonText: 'No',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    callback();
                }
            });
        }
    
        setShowModal(true);
    };
    
    
    const toggleVisibilityHandlers = () => {
        if (isVisibleMembers) {
            setErrorMessage('Stai aggiungendo i Dipendenti, completa l\'operazione o seleziona "Annulla" per abilitare l\'aggiunta di Gestori');
            setSelectedEmployeesHandlers([]);
        } else {
            setIsVisibleHandlers(!isVisibleHandlers);
            setSelectedEmployeesHandlers([]);
            setErrorMessage('');
        }
    };
    
    const toggleVisibilityMembers = () => {
        if (isVisibleHandlers) {
            setErrorMessage('Stai aggiungendo i Gestori, completa l\'operazione o seleziona "Annulla" per abilitare l\'aggiunta di Dipendenti');
            setSelectedEmployeesMembers([]);
        } else {
            setIsVisibleMembers(!isVisibleMembers);
            setSelectedEmployeesMembers([]);
            setErrorMessage('');
        }
    };

    const handleSelectionChangeHandlers = (newSelectedEmployees) => {
        setSelectedEmployeesHandlers(newSelectedEmployees);
        setErrorMessage('');
    };

    const handleSelectionChangeMembers = (newSelectedEmployees) => {
        setSelectedEmployeesMembers(newSelectedEmployees);
        setErrorMessage('');
    };

    const handleUnselectEmployee = (employeeId, listType) => {
        if (listType === 'handlers') {
            const updatedSelectedEmployees = selectedEmployeesHandlers.filter(employee => employee.id !== employeeId);
            setSelectedEmployeesHandlers(updatedSelectedEmployees);
        } else if (listType === 'members') {
            const updatedSelectedEmployees = selectedEmployeesMembers.filter(employee => employee.id !== employeeId);
            setSelectedEmployeesMembers(updatedSelectedEmployees);
        }
    }; 

    const handleSaveHandlers = async (employees) => {
        try {
            setIsSaving(true);

            if (ou_id) {
                await Promise.all(employees.map(employee => addHandlerToOrganizationalUnit(token, ou_id, employee.id)));
                
                const updatedUnitData = await getOrganizationalUnit(token, ou_id);
                setUnitData(updatedUnitData.data);
                toggleVisibilityHandlers();
                handleSelectionChangeHandlers([]);
            } else {
                console.error("ou_id è undefined");
            }
        } catch (error) {
            console.error("Errore durante l'aggiunta dei dipendenti all'unità organizzativa:", error);
        } finally {
            setIsSaving(false);
        }
    };

    const handleSaveMembers = async (employees) => {
        try {
            setIsSaving(true);

            if (ou_id) {
                await Promise.all(employees.map(employee => addMemberToOrganizationalUnit(token, ou_id, employee.id)));
                
                const updatedUnitData = await getOrganizationalUnit(token, ou_id);
                setUnitData(updatedUnitData.data);
                toggleVisibilityMembers();
                handleSelectionChangeMembers([]);
            } else {
                console.error("ou_id è undefined");
            }
        } catch (error) {
            console.error("Errore durante l'aggiunta dei dipendenti all'unità organizzativa:", error);
        } finally {
            setIsSaving(false);
        }
    };
    
    const handleRemoveEmployeeOU = async (employee_id) => {
        try {
            if (!ou_id) {
                console.error("ou_id è undefined");
                return;
            }
    
            await removeEmployeeFromOrganizationalUnit(token, ou_id, employee_id);
    
            const updatedUnitData = await getOrganizationalUnit(token, ou_id);
            setUnitData(updatedUnitData.data);    

            const updatedAvailableEmployees = await getEmployeesWithActiveContract(token);
            setDipendenti(updatedAvailableEmployees);
        } catch (error) {
            console.error("Errore durante la rimozione del dipendente dall'unità organizzativa:", error);
        }
    };

    useEffect(() => {
        if (errorMessage && errorRef.current) {
          errorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, [errorMessage]);

    const handleAddPermissions = () => {
        setShowPermissionsTable(true);
    };

    const handlePermissionChange = async (permissionId, isChecked) => {
        try {
            if (isChecked) {
                await addOusPermission(token, ou_id, permissionId);
            } else {
                await removeOusPermission(token, ou_id, permissionId);
            }
            const activePermissions = await getOusPermissions(token, ou_id);
            setOuPermissions(activePermissions);
        } catch (error) {
            console.error("Errore durante l'aggiornamento dei permessi:", error);
            Swal.fire({
                icon: 'error',
                title: 'Errore',
                text: 'Si è verificato un errore durante l\'aggiornamento dei permessi.',
            });
        }
    };
    
    
    if(isLoading)
        return <Fetching />;

    if (isError) return <div>Error loading data</div>;

    return (
        <div className="min-h-full">
            <PopoverComponentCustom
                title={
                    <>
                        Unità Organizzativa:&nbsp;
                        <span className="uppercase">{unitData.name}</span>
                    </>
                }
            />
            <main className="mt-10 pb-8 px-5">
                <div className='container mx-auto px-5 m-5'>

                    <div className='grid grid-cols-2'>
                        <div className='col-span-1'>
                            <button>
                                <Link to="/organization" className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600 hover:bg-gray-100">Torna indietro</Link>
                            </button>
                            
                        </div>
                        <div className='col-span-1 flex justify-end'>
                            <button 
                                className="flex items-center justify-center text-gray-700 font-semibold px-1 border border-solid shadow-md me-3 rounded-md hover:bg-gray-100" 
                                title="Modifica" 
                            >
                                <Link to={`/organization/${ou_id}/edit`} className='flex items-center'>
                                    <p className='p-2 text-sm sm:block hidden'>Modifica</p>
                                    <PencilIcon className="h-6 w-6 text-indigo-600" />
                                </Link>
                            </button>
                            <button 
                                type='button'
                                onClick={handleDeleteOu}
                                className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            >
                            <p className='sm:block hidden'>Elimina Unità</p>
                            <TrashIcon className="-mr-0.5 h-5 w-5" />
                            </button>
                        </div>
                    </div>
                                  
                    {/* Unità di appartenenza */}
                    <div className='border border-solid-2 border-gray-200 shadow-md rounded-md my-5'>
                        <div className='bg-gray-100 p-3 flex items-center'>
                            <h4 className='text-sm font-semibold uppercase flex items-center justify-items-center'>
                                Unità di Appartenenza
                            </h4>
                        </div>
                        {/* {(unitData.parent ? (
                            <p className='p-3 text-sm'>{unitData.parent}</p>
                        ) : (
                            <p className='p-3 text-sm'>Non è presente un'unità padre</p>)
                        )} */}
                        <p className='p-3 text-sm'>
                            {parentUnitData ? parentUnitData.name : 'Nessuna unità di appartenenza'}
                        </p>
                    </div>

                    {profile.customer_type !== 'employee' && (
                        <div className='border border-solid-2 border-gray-200 shadow-md rounded-md my-5'>
                            <div className='bg-gray-100 p-3 flex items-center'>
                                <h4 className='text-sm font-semibold uppercase flex items-center justify-items-center me-3'>
                                    Permessi dell'unità organizzativa
                                </h4>
                                {!showPermissionsTable ? (
                                    <div 
                                        className='relative w-24 justify-center inline-flex items-center rounded-sm bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                                        onClick={handleAddPermissions}
                                    >
                                        Aggiungi
                                    </div>
                                ) : (
                                    <div 
                                        className='relative w-24 justify-center inline-flex items-center rounded-sm bg-gray-500 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-gray-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
                                        onClick={() => setShowPermissionsTable(false)}
                                    >
                                        Chiudi
                                    </div>
                                )}
                            </div>

                            {showPermissionsTable ? (
                                <div className='p-4 text-sm'>
                                    <PermissionsTable
                                        activePermissions={ouPermissions.map(permission => permission.id)} 
                                        onChange={handlePermissionChange}
                                    />
                                </div>
                            ) : (
                                <div className='p-3 text-sm'>
                                    {ouPermissions.length > 0 ? (
                                        <>
                                            <h4 className="font-semibold text-sm uppercase text-indigo-800 mb-2">Permessi assegnati ai gestori dell'unità</h4>
                                            <div className='grid grid-cols-2 gap-4 mb-4'>
                                                {ouPermissions.filter(permission => permission.role === 'handler').length > 0 ? (
                                                    ouPermissions
                                                        .filter(permission => permission.role === 'handler')
                                                        .map(permission => (
                                                            <div key={permission.id} className="text-gray-800 flex items-center">
                                                                <CheckIcon className="h-4 w-4 text-indigo-600 mr-2" />
                                                                {permission.name}
                                                            </div>
                                                        ))
                                                ) : (
                                                    <p>Non sono presenti permessi per i gestori dell'unità</p>
                                                )}
                                            </div>
                                            <h4 className="font-semibold text-sm uppercase text-indigo-800 mb-2">Permessi assegnati ai dipendenti dell'unità</h4>
                                            <div className='grid grid-cols-2 gap-4'>
                                                {ouPermissions.filter(permission => permission.role === 'employee').length > 0 ? (
                                                    ouPermissions
                                                        .filter(permission => permission.role === 'employee')
                                                        .map(permission => (
                                                            <div key={permission.id} className="text-gray-800 flex items-center">
                                                                <CheckIcon className="h-4 w-4 text-indigo-600 mr-2" />
                                                                {permission.name}
                                                            </div>
                                                        ))
                                                ) : (
                                                    <p>Non sono presenti permessi per i dipendenti dell'unità</p>
                                                )}
                                            </div>
                                        </>
                                    ) : (
                                        <p>Nessun permesso attivo per questa unità</p>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {errorMessage && <p ref={errorRef} className="text-red-500 px-3 text-sm text-center">{errorMessage}</p>}

                    <OrgAddEmployeeRoleHandlers
                        unitData={unitData}
                        isVisibleHandlers={isVisibleHandlers}
                        selectedEmployeesHandlers={selectedEmployeesHandlers}
                        handleSelectionChangeHandlers={handleSelectionChangeHandlers}
                        toggleVisibilityHandlers={toggleVisibilityHandlers}
                        handleUnselectEmployee={handleUnselectEmployee}
                        handleSaveHandlers={handleSaveHandlers}
                        handleRemoveEmployeeOU={handleRemoveEmployeeOU}
                        isSaving={isSaving}
                        token={token}
                    />

                    <OrgAddEmployeeRoleMembers
                        unitData={unitData}
                        token={token}
                        isVisibleMembers={isVisibleMembers}
                        selectedEmployeesMembers={selectedEmployeesMembers}
                        handleSelectionChangeMembers={handleSelectionChangeMembers}
                        toggleVisibilityMembers={toggleVisibilityMembers}
                        handleUnselectEmployee={handleUnselectEmployee}
                        handleSaveMembers={handleSaveMembers}
                        handleRemoveEmployeeOU={handleRemoveEmployeeOU}
                        isSaving={isSaving}
                    />

                </div>
            </main>
            <Footer />
        </div>
    )
};
